module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "grid fixed h100",
    staticStyle: {
      "grid-template-columns": "auto 1fr",
      "grid-template-rows": "auto auto"
    }
  }, [_c('navbar', {
    attrs: {
      "hotel": _vm.hotel,
      "settings": _vm.settings
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "grid cashier h100"
  }, [_c('div', {
    staticClass: "grid seasons"
  }, [_c('div', {
    staticClass: "grid enable"
  }, [_c('span', [_c('strong', [_vm._v(_vm._s(_vm.hotel.name) + " - Stagioni e pagamenti ombrellone")])]), _vm._v(" "), _c('span', [_c('el-switch', {
    attrs: {
      "active-color": "#13ce66",
      "inactive-color": "#ff4949"
    },
    on: {
      "change": _vm.editcashier
    },
    model: {
      value: (_vm.hotel.cashier),
      callback: function($$v) {
        _vm.$set(_vm.hotel, "cashier", $$v)
      },
      expression: "hotel.cashier"
    }
  })], 1), _vm._v(" "), _c('span', [(_vm.hotel.cashier) ? _c('button', {
    staticClass: "btn btn-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addseason
    }
  }, [_c('i', {
    staticClass: "fas fa-plus-square"
  }), _vm._v(" aggiungi stagione")]) : _vm._e()])]), _vm._v(" "), (_vm.hotel && _vm.hotel.seasons.length === 0) ? _c('p', [_vm._v("Aggiungi la tua prima stagione")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.hotel.seasons), function(season, index) {
    return (_vm.hotel.cashier) ? _c('div', {
      staticClass: "grid season"
    }, [_c('span', [_vm._v(_vm._s(season.name))]), _vm._v(" "), _c('div', {
      staticClass: "grid data"
    }, [_c('span', [_c('small', [_vm._v(_vm._s(season.start) + " > " + _vm._s(season.end))])]), _vm._v(" "), _c('span', [_c('small', [_vm._v("€ " + _vm._s(season.amount))])]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-edit",
      on: {
        "click": function($event) {
          return _vm.editseason(season, index)
        }
      }
    })])]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "grid items"
  }, [(_vm.newseason || _vm.updateseason) ? _c('div', {
    staticClass: "grid addseason"
  }, [(_vm.newseason) ? _c('span', [_c('strong', [_vm._v("Aggiungi stagione")])]) : _vm._e(), _vm._v(" "), (_vm.updateseason) ? _c('span', [_c('strong', [_vm._v("Update stagione " + _vm._s(_vm.season.name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form', {
    ref: "addseasonForm",
    attrs: {
      "model": _vm.season,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Denominazione stagione",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Denominazione stagione",
      "name": "name"
    },
    model: {
      value: (_vm.season.name),
      callback: function($$v) {
        _vm.$set(_vm.season, "name", $$v)
      },
      expression: "season.name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "spacer xs"
  }), _vm._v(" "), _c('el-form-item', [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "al",
      "start-placeholder": "Start date",
      "end-placeholder": "End date",
      "format": "dd-MM-yyyy",
      "picker-options": _vm.datePickerOptions
    },
    on: {
      "change": function($event) {
        return _vm.changeRange()
      }
    },
    model: {
      value: (_vm.season.daterange),
      callback: function($$v) {
        _vm.$set(_vm.season, "daterange", $$v)
      },
      expression: "season.daterange"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Prezzo base ombrellone"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "Prezzo ombrellone",
      "name": "ombrellone"
    },
    model: {
      value: (_vm.season.amount),
      callback: function($$v) {
        _vm.$set(_vm.season, "amount", $$v)
      },
      expression: "season.amount"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("€")])], 2)], 1), _vm._v(" "), _vm._l((_vm.season.items), function(item) {
    return _c('div', [_c('el-form-item', {
      attrs: {
        "label": 'Prezzo base ' + item.name
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Prezzo oggetto",
        "name": "price"
      },
      model: {
        value: (item.price),
        callback: function($$v) {
          _vm.$set(item, "price", $$v)
        },
        expression: "item.price"
      }
    }, [_c('template', {
      slot: "prepend"
    }, [_vm._v("€")])], 2)], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "spacer sm"
  }), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [(_vm.newseason) ? _c('el-button', {
    staticClass: "btn btn-green",
    on: {
      "click": function($event) {
        return _vm.addnewseason('addseasonForm')
      }
    }
  }, [_vm._v("aggiungi stagione")]) : _vm._e(), _vm._v(" "), (_vm.updateseason) ? _c('el-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-trash"
  })]) : _vm._e(), _vm._v(" "), (_vm.updateseason) ? _c('el-button', {
    staticClass: "btn btn-green",
    on: {
      "click": function($event) {
        return _vm.saveseason('addseasonForm', _vm.season.index)
      }
    }
  }, [_vm._v("salva impostazioni stagione")]) : _vm._e()], 1)])], 2)], 1) : _vm._e()])]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "Attenzione",
      "visible": _vm.dialogVisible,
      "width": "25%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('p', [_vm._v("Sei sicuro di voler cancellare la stagione " + _vm._s(_vm.season.name) + "?")]), _vm._v(" "), _c('p', [_vm._v("Tutti i dati verranno cancellati.")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Anulla")]), _vm._v(" "), _c('el-button', {
    staticClass: "btn btn-red",
    on: {
      "click": function($event) {
        return _vm.deleteseason(_vm.season.index)
      }
    }
  }, [_vm._v("Cancella")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2253852e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pagamenti.vue
// module id = 623
// module chunks = 1